import { API_ENDPOINTS } from '@tsgecart/config';
import { storefrontApiFetch } from '../../../../lib/api/storefront-client.js';
import type { CouponValidationResult } from '../types/coupon.js';

export interface FetchOptions {
  token: string;
  signal?: AbortSignal;
}

/**
 * Preview-only eligibility/discount check against `POST /coupons/validate`.
 * Does NOT apply the coupon to the cart -- there is no cart-level coupon
 * state on the backend. The code is only actually applied at checkout
 * (checkout-preview / order creation, built by another agent). Callers
 * should treat a successful response with `valid: false` as a normal
 * result to display, not an error.
 */
export async function validateCoupon(code: string, options: FetchOptions): Promise<CouponValidationResult> {
  return storefrontApiFetch<CouponValidationResult>(`${API_ENDPOINTS.coupons}/validate`, {
    ...options,
    method: 'POST',
    body: { code },
  });
}
